import {
  provideHttpClient,
  withFetch,
  withInterceptors
} from '@angular/common/http';
import {
  ApplicationConfig,
  importProvidersFrom,
  provideZoneChangeDetection
} from '@angular/core';
import {
  provideClientHydration,
  withEventReplay
} from '@angular/platform-browser';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import {
  provideRouter,
  withComponentInputBinding,
  withRouterConfig
} from '@angular/router';
import { environment } from '@environments/environment';
import { TranslateModule } from '@ngx-translate/core';
import { provideTranslation } from '@shared/factory/http-loader.factory';
import { AuthInterceptor } from '@shared/interceptor.basic-auth';
import { GoogleTagManagerModule } from 'angular-google-tag-manager';
import { repositoryProviders } from '../data/providers/repository.provider';
import { routes } from './app.routes';
import { DeviceIdService } from './shared/services/device-id/device-id.service';
import {CookieService} from 'ngx-cookie-service';

const nonProductionInterceptor = environment.production
  ? []
  : [AuthInterceptor];

export const appConfig: ApplicationConfig = {
  providers: [
    repositoryProviders(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(
      routes,
      withRouterConfig({
        onSameUrlNavigation: 'reload'
      }),
      withComponentInputBinding()
    ),
    provideClientHydration(withEventReplay()),
    provideAnimationsAsync(),
    importProvidersFrom([
      TranslateModule.forRoot(provideTranslation()),
      GoogleTagManagerModule.forRoot({
        id: environment.gtmKey
      })
    ]),
    provideHttpClient(
      withFetch(),
      withInterceptors([
        ...nonProductionInterceptor
      ])
    ),
    DeviceIdService,
    CookieService,
    { provide: 'googleTagManagerId', useValue: environment.gtmKey }
  ]
};
